(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-rituals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tc-shop-rituals-carousel')) return;

    class TcShopRitualsCarousel extends HTMLElement {
      connectedCallback() {
        if (this.__tcInitialized) return;
        this.__tcInitialized = true;
        this.__stopped = false;

        this.viewport = this.querySelector('.tc-shop-rituals__viewport');
        this.track = this.querySelector('.tc-shop-rituals__track');
        if (!this.viewport || !this.track) return;

        this.originalCards = Array.from(this.track.children);
        if (this.originalCards.length === 0) return;

        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.speed = parseFloat(this.dataset.speed) || 40;
        this.direction = this.dataset.direction === 'right' ? 1 : -1;
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';

        this.position = 0;
        this.setWidth = 0;
        this.cardWidth = 0;
        this.gap = 0;
        this.hovering = false;
        this.interacting = false;
        this.unmutedVideo = null;
        this.suppressClick = false;
        this.pointerId = null;
        this.lastTime = null;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reducedMotion = this.motionQuery.matches;
        this.onMotionChange = (e) => {
          this.reducedMotion = e.matches;
        };
        if (this.motionQuery.addEventListener) {
          this.motionQuery.addEventListener('change', this.onMotionChange);
        } else if (this.motionQuery.addListener) {
          this.motionQuery.addListener(this.onMotionChange);
        }

        this._boundTick = this.tick.bind(this);
        this._boundPointerMove = this.onPointerMove.bind(this);
        this._boundPointerUp = this.onPointerUp.bind(this);

        this.setupClones();
        this.setupResize();
        this.setupHover();
        this.setupPointer();
        this.setupVideoObserver();
        this.setupMuteButtons();
        this.setupClickGuard();

        requestAnimationFrame(this._boundTick);
      }

      disconnectedCallback() {
        this.__stopped = true;
        this.__tcInitialized = false;

        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.videoObserver) this.videoObserver.disconnect();

        if (this.motionQuery) {
          if (this.motionQuery.removeEventListener) {
            this.motionQuery.removeEventListener('change', this.onMotionChange);
          } else if (this.motionQuery.removeListener) {
            this.motionQuery.removeListener(this.onMotionChange);
          }
        }

        window.removeEventListener('pointermove', this._boundPointerMove);
        window.removeEventListener('pointerup', this._boundPointerUp);
        window.removeEventListener('pointercancel', this._boundPointerUp);
      }

      setupClones() {
        const rect = this.viewport.getBoundingClientRect();
        const viewportWidth = rect.width || window.innerWidth;
        const styles = getComputedStyle(this.viewport.closest('.tc-shop-rituals__inner') || this);
        const gap = parseFloat(styles.getPropertyValue('--tc-gap')) || 16;
        const cardsVisible = parseFloat(styles.getPropertyValue('--tc-cards')) || 3;
        const approxCardWidth = Math.max(1, (viewportWidth - gap * (cardsVisible - 1)) / cardsVisible);
        const oneSetWidth = this.originalCards.length * (approxCardWidth + gap);

        let sets = 2;
        const maxSets = 6;
        while (sets * oneSetWidth < viewportWidth * 3 && sets < maxSets) {
          sets++;
        }

        for (let i = 1; i < sets; i++) {
          this.originalCards.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.classList.add('tc-shop-rituals__card--clone');
            clone.querySelectorAll('a, button, [tabindex]').forEach((el) => {
              el.setAttribute('tabindex', '-1');
            });
            clone.querySelectorAll('video').forEach((v) => {
              v.muted = true;
              v.removeAttribute('id');
            });
            this.track.appendChild(clone);
          });
        }
      }

      setupResize() {
        this.resizeObserver = new ResizeObserver(() => this.updateCardWidth());
        this.resizeObserver.observe(this.viewport);
        this.updateCardWidth();
      }

      updateCardWidth() {
        const viewportWidth = this.viewport.getBoundingClientRect().width;
        if (!viewportWidth) return;
        const styles = getComputedStyle(this.viewport.closest('.tc-shop-rituals__inner') || this);
        const gap = parseFloat(styles.getPropertyValue('--tc-gap')) || 16;
        const cardsVisible = parseFloat(styles.getPropertyValue('--tc-cards')) || 3;
        const cardWidth = Math.max(1, (viewportWidth - gap * (cardsVisible - 1)) / cardsVisible);

        this.style.setProperty('--tc-card-w', cardWidth + 'px');
        this.cardWidth = cardWidth;
        this.gap = gap;
        this.setWidth = this.originalCards.length * (cardWidth + gap);

        this.normalizePosition();
        this.applyTransform();
      }

      normalizePosition() {
        if (!this.setWidth) return;
        this.position = this.position % this.setWidth;
        if (this.position > 0) this.position -= this.setWidth;
      }

      applyTransform() {
        this.track.style.transform = 'translate3d(' + this.position + 'px,0,0)';
      }

      tick(timestamp) {
        if (this.__stopped) return;
        if (this.lastTime == null) this.lastTime = timestamp;
        const dt = Math.min((timestamp - this.lastTime) / 1000, 0.1);
        this.lastTime = timestamp;

        const paused =
          this.reducedMotion ||
          !this.autoplayEnabled ||
          (this.pauseOnHover && this.hovering) ||
          this.interacting ||
          !!this.unmutedVideo;

        if (!paused && this.setWidth) {
          this.position += this.direction * this.speed * dt;
          this.normalizePosition();
          this.applyTransform();
        }

        requestAnimationFrame(this._boundTick);
      }

      setupHover() {
        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') this.hovering = true;
        });
        this.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'mouse') this.hovering = false;
        });
      }

      setupPointer() {
        this.dragStartX = 0;
        this.dragStartY = 0;
        this.dragStartPos = 0;
        this.dragDecided = false;
        this.isHorizontalDrag = false;
        this.dragMoved = false;

        this.viewport.addEventListener('pointerdown', (e) => this.onPointerDown(e));
        window.addEventListener('pointermove', this._boundPointerMove, { passive: false });
        window.addEventListener('pointerup', this._boundPointerUp);
        window.addEventListener('pointercancel', this._boundPointerUp);
      }

      onPointerDown(e) {
        if (e.target.closest && e.target.closest('.tc-shop-rituals__mute-btn')) return;
        this.pointerId = e.pointerId;
        this.dragStartX = e.clientX;
        this.dragStartY = e.clientY;
        this.dragStartPos = this.position;
        this.dragDecided = false;
        this.isHorizontalDrag = false;
        this.dragMoved = false;
        this.interacting = true;
      }

      onPointerMove(e) {
        if (this.pointerId === null || e.pointerId !== this.pointerId) return;
        const dx = e.clientX - this.dragStartX;
        const dy = e.clientY - this.dragStartY;

        if (!this.dragDecided) {
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
            this.dragDecided = true;
            this.isHorizontalDrag = Math.abs(dx) > Math.abs(dy);
            if (this.isHorizontalDrag && this.viewport.setPointerCapture) {
              try {
                this.viewport.setPointerCapture(this.pointerId);
              } catch (err) {
                /* noop */
              }
            }
          }
        }

        if (this.isHorizontalDrag) {
          if (e.cancelable) e.preventDefault();
          this.dragMoved = true;
          this.position = this.dragStartPos + dx;
          this.normalizePosition();
          this.applyTransform();
        }
      }

      onPointerUp(e) {
        if (this.pointerId === null || e.pointerId !== this.pointerId) return;
        if (this.isHorizontalDrag && this.dragMoved) {
          this.suppressClick = true;
        }
        this.pointerId = null;
        this.interacting = false;
        this.isHorizontalDrag = false;
        this.dragDecided = false;
        this.dragMoved = false;
      }

      setupClickGuard() {
        this.addEventListener(
          'click',
          (e) => {
            if (e.target.closest && e.target.closest('.tc-shop-rituals__card--clone')) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            if (this.suppressClick) {
              e.preventDefault();
              e.stopPropagation();
              this.suppressClick = false;
            }
          },
          true
        );
      }

      setupMuteButtons() {
        this.addEventListener('click', (e) => {
          const btn = e.target.closest ? e.target.closest('.tc-shop-rituals__mute-btn') : null;
          if (!btn) return;
          if (btn.closest('.tc-shop-rituals__card--clone')) return;

          e.preventDefault();
          e.stopPropagation();

          const card = btn.closest('.tc-shop-rituals__card');
          const video = card ? card.querySelector('video') : null;
          if (!video) return;

          if (video.muted) {
            this.querySelectorAll('video').forEach((v) => {
              if (v !== video) {
                v.muted = true;
                const otherCard = v.closest('.tc-shop-rituals__card');
                const otherBtn = otherCard ? otherCard.querySelector('.tc-shop-rituals__mute-btn') : null;
                if (otherBtn) this.setMuteButtonState(otherBtn, true);
              }
            });
            video.muted = false;
            this.unmutedVideo = video;
            this.setMuteButtonState(btn, false);
          } else {
            video.muted = true;
            this.unmutedVideo = null;
            this.setMuteButtonState(btn, true);
          }
        });
      }

      setMuteButtonState(btn, muted) {
        btn.classList.toggle('is-unmuted', !muted);
        btn.setAttribute('aria-pressed', String(!muted));
        btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      setupVideoObserver() {
        const videos = Array.from(this.querySelectorAll('video'));
        if (!videos.length) return;

        this.videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const v = entry.target;
              if (entry.isIntersecting) {
                const p = v.play();
                if (p && p.catch) p.catch(() => {});
              } else {
                v.pause();
              }
            });
          },
          { root: null, rootMargin: '200px', threshold: 0 }
        );

        videos.forEach((v) => {
          v.muted = true;
          this.videoObserver.observe(v);
        });
      }
    }

    customElements.define('tc-shop-rituals-carousel', TcShopRitualsCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
